import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from "react-select";
import {
    Grid,
    Typography,
    Card,
    CardContent,
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Chip,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from "@material-ui/core";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Cell
} from "recharts";
import CloseIcon from '@material-ui/icons/Close';

import ApiServer from "../../common/js/ApiServices";
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import AsideComponent from "../includes/asideComponent/AsideComponent";
import styles from "./PeerBenchmarking.css"; 
import { startLoader, stopLoader } from '../../actions/loaderActions';


class PeerBenchmarking extends React.Component {
    static defaultProps = {
        config: {
            title: "Peer Benchmarking",
            breadcrumb: "Peer Benchmarking",
            filters: {
                domain: { label: "Domain", key: "domain_name" },
                industry: { label: "Industry", key: "industry" },
                year: { label: "Financial Year", key: "financial_year" }
            },
            api: {
                filters: "/peer-benchmarking/filters",
                overview: "/peer-benchmarking/domains",
                drilldown: "/peer-benchmarking/first-drilldown",
                details: "/peer-benchmarking/second-drilldown"
            },
            primaryDomain: "Environment", // For consistent sorting
            defaultDomainFilter: "all"
        }
    }

    constructor(props) {
        super(props);
        this.apiServer = new ApiServer(true);

        this.state = {
            metricOptions: [],
            industryOptions: [],
            yearOptions: [],
            selectedMetric: null,
            selectedIndustry: null,
            selectedYear: null,
            chartData: [],
            peers: [],
            domainColorMap: {},
            drilldownMode: false,
            drilldownTitle: "",
            drilldownChartData: [],
            activeDrilldownDomain: null,
            activeDrilldownPeer: null,
            variableDialogOpen: false,
            variableDialogSubdomain: '',
            variableList: [],
            dataDialogOpen: false,
            fulldata: []
        };
        this.colorPalette = [
            "#2ca02c", "#ff7300", "#1f77d0", "#9467bd", "#8c564b",
            "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"
        ];
    }

    componentDidMount() {
        this.props.startLoader();
        const { config } = this.props;
        
        this.apiServer.SendRequest({ method: "GET", url: config.api.filters })
            .then(res => {
                const data = res.data;

                const industryOptions = data.industries.map(i => ({
                    label: i.industry,
                    value: i.industry_id
                }));

                const yearOptions = data.years.map(y => ({
                    label: y.financial_year.toString(),
                    value: y.financial_year
                }));

                const metricOptions = [
                    { label: "All", value: config.defaultDomainFilter },
                    ...data.metrics.map(m => ({
                        label: m.domain_name,
                        value: m.domain_name.toLowerCase()
                    }))
                ];

                this.setState({
                    industryOptions,
                    yearOptions,
                    metricOptions,
                    selectedIndustry: industryOptions[0] || null,
                    selectedYear: yearOptions[0] || null,
                    selectedMetric: metricOptions[0] || null
                }, this.fetchChartData);
            });
    }

    fetchChartData = () => {
        this.props.startLoader();
        const { selectedMetric, selectedIndustry, selectedYear } = this.state;
        const { config } = this.props;
      
        if (selectedMetric && selectedIndustry && selectedYear) {
          this.apiServer.SendRequest({
            method: "GET",
            url: config.api.overview,
            data: {
              domain_name: selectedMetric.value,
              industry: selectedIndustry.value,
              financial_year: selectedYear.value
            }
          }).then(res => {
            this.props.stopLoader();
            const rawData = res.data || [];
      
            let peerOrder = rawData
              .filter(d => d.domain_name === config.primaryDomain)
              .map(d => d.peer_name);
      
            if (peerOrder.length === 0) {
              const allPeers = Array.from(new Set(rawData.map(d => d.peer_name)));
              peerOrder = allPeers.sort();
            }
      
            const domainGroupedData = {};
            const domains = [...new Set(rawData.map(d => d.domain_name))];
      
            domains.forEach(domain => {
              const domainData = rawData.filter(d => d.domain_name === domain);
              domainGroupedData[domain] = peerOrder.map(peer => {
                const match = domainData.find(d => d.peer_name === peer);
                return {
                  name: peer,
                  score: match ? match.domain_score : 0,
                  peer_id: match ? match.peer_id : null
                };
              });
            });
      
            const domainColorMap = {};
            domains.forEach((domain, idx) => {
              domainColorMap[domain] = this.colorPalette[idx % this.colorPalette.length];
            });
      
            this.setState({
              chartData: domainGroupedData,
              domainColorMap
            });
          }).catch(err => {
            this.props.stopLoader();
            console.error("Error fetching chart data:", err);
          });
        }
      };
      
      
      
      
    handleChange = (field, selectedOption) => {
        this.setState({ [field]: selectedOption }, this.fetchChartData);
    };

    getDomainColor = (domain) => {
        if (!this.domainColorMap[domain]) {
          const color = this.colorPalette[this.nextColorIndex % this.colorPalette.length];
          this.domainColorMap[domain] = color;
          this.nextColorIndex++;
        }
        return this.domainColorMap[domain];

      };

      handleDrilldown = (domain) => {
        this.props.startLoader();
        const { selectedYear, chartData } = this.state;
        const { config } = this.props;
      
        if (!chartData || !chartData[domain]) {
          console.warn("No data found for domain:", domain);
          return;
        }
      
        const peerIds = chartData[domain]
          .map(d => d.peer_id)
          .filter(id => id != null)
          .join(",");
      
        const year = selectedYear?.value;
      
        const queryParams = new URLSearchParams({
          peer_ids: peerIds,
          domain_name: domain,
          ...(year ? { financial_year: year } : {})
        }).toString();
      
        const url = `${config.api.drilldown}?${queryParams}`;
      
        this.apiServer.SendRequest({ method: "GET", url }).then((res) => {
          this.props.stopLoader();
          const drilldownDataRaw = res.data || [];
          const grouped = {};
      
          drilldownDataRaw.forEach(({ sub_domain_name, peer_name, sub_domain_score }) => {
            if (!grouped[sub_domain_name]) grouped[sub_domain_name] = [];
            grouped[sub_domain_name].push({ peer_name, sub_domain_score, sub_domain_name });
          });

          const uniqueSubdomains = [...new Set(drilldownDataRaw.map(item => item.sub_domain_name))];

          const domainColorMap = {};
          uniqueSubdomains.forEach((subdomain, idx) => {
            domainColorMap[subdomain] = this.colorPalette[idx % this.colorPalette.length];
          });
      
          this.setState({
            drilldownMode: true,
            drilldownTitle: `${domain} Details`,
            drilldownChartData: grouped, 
            activeDrilldownDomain: domain,
            activeDrilldownPeer: peerIds,
            domainColorMap: domainColorMap
          });
        }).catch((err) => {
          this.props.stopLoader();
          console.error("Drilldown API error:", err);
        });
      };

      handleViewVariables = (subdomain, type) => {
        this.props.startLoader();
        const { config } = this.props;
        const url = `${config.api.details}?sub_domain_name=${encodeURIComponent(subdomain)}`;
      
        this.apiServer.SendRequest({ method: "GET", url })
          .then((res) => {
            const formatted = res?.variable_names || [];
            const fulldata = res?.data || [];
            this.props.stopLoader();
            this.setState({
              variableDialogOpen: type === 'variables',
              variableDialogSubdomain: subdomain,
              variableList: formatted,
              fulldata: fulldata,
              dataDialogOpen: type === 'data'
            });
          })
          .catch((err) => {
            this.props.stopLoader();
            console.error("Error fetching detailed data:", err);
          });
      };
      
      
      
      handleBack = () => {
        this.setState({
          drilldownMode: false,
          drilldownTitle: "",
          drilldownChartData: [],
          activeDrilldownDomain: null,
          activeDrilldownPeer: null
        }, this.fetchChartData); 
      };

      formatSubdomain = (key) => {
        if (!key) return "";
        
        let formatted = key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase());
      
        // Replace specific acronyms with uppercase
        formatted = formatted
          .replace(/\bCsr\b/g, "CSR")
          .replace(/\bGhg\b/g, "GHG");
      
        return formatted;
      };
      render() {
        const { config } = this.props;
        const {
            metricOptions,
            industryOptions,
            yearOptions,
            selectedMetric,
            selectedIndustry,
            selectedYear,
            chartData,
            peers,
        } = this.state;

        return [
            <DashboardHeader key="header" />,
            <div id="wrapper" key="wrapper">
                <DashboardSidebar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <ol className="breadcrumb dashbread">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item active">{config.breadcrumb}</li>
                            <li className="breadcrumb-menu d-md-down-none ml-auto">
                                <img
                                    src={require('./../../common/images/diva-icon.png')}
                                    className="logo-img"
                                    alt="Logo"
                                />
                                <a className="btn powered p-0" href="#">
                                    <i className="icon-graph"></i> &nbsp;
                                    <i>Powered by Amploglobal</i>
                                </a>
                            </li>
                        </ol>
                        <div className="container mt-4">
                            <div className="main-content">
                                <div className={styles.peerBenchmarkingContainer}>
                                    <Grid container spacing={2} className={styles.filterRow}>
                                        <Grid item xs={12} md={4}>
                                            <Typography variant="subtitle2" style={{ marginBottom: 8 }}><b>{config.filters.domain.label}</b></Typography>
                                            <Select
                                                options={metricOptions}
                                                value={selectedMetric}
                                                onChange={(opt) => this.handleChange("selectedMetric", opt)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Typography variant="subtitle2" style={{ marginBottom: 8 }}><b>{config.filters.industry.label}</b></Typography>
                                            <Select
                                                options={industryOptions}
                                                value={selectedIndustry}
                                                onChange={(opt) => this.handleChange("selectedIndustry", opt)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Typography variant="subtitle2" style={{ marginBottom: 8 }}><b>{config.filters.year.label}</b></Typography>
                                            <Select
                                                options={yearOptions}
                                                value={selectedYear}
                                                onChange={(opt) => this.handleChange("selectedYear", opt)}
                                            />
                                        </Grid>
                                    </Grid>

                                    {this.state.drilldownMode ? (
                                        <div style={{ marginTop: 24 }}>
                                            <Box className={styles.drilldownHeader}>
                                                <Typography variant="h5" style={{ fontWeight: 700 }}>{this.state.drilldownTitle}</Typography>
                                                <Button variant="outlined" className={styles.navButton} onClick={this.handleBack}>Back to Overview</Button>
                                            </Box>
                                            
                                            {Object.entries(this.state.drilldownChartData).map(([subdomain, data]) => (
                                                <Card key={subdomain} className={styles.chartCard}>
                                                    <CardContent>
                                                        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                                                            <Typography variant="h6" style={{ fontWeight: 700 }}>
                                                                {this.formatSubdomain(subdomain)} Score Comparison
                                                            </Typography>
                                                            <Box display="flex" gap={2}>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    className={styles.navButton}
                                                                    onClick={() => this.handleViewVariables(subdomain, 'variables')}
                                                                >
                                                                    View Variables
                                                                </Button>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    className={styles.navButton}
                                                                    onClick={() => this.handleViewVariables(subdomain, 'data')}
                                                                >
                                                                    View Data
                                                                </Button>
                                                            </Box>
                                                        </Box>
                                                        
                                                        <Box mt={4}>
                                                            <ResponsiveContainer width="100%" height={350}>
                                                                <BarChart
                                                                    data={data}
                                                                    margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                                                                    barCategoryGap="40%"
                                                                >
                                                                    <XAxis 
                                                                        dataKey="peer_name" 
                                                                        interval={0} 
                                                                        tick={{ fontSize: 12, fontWeight: 600 }}
                                                                        axisLine={{ stroke: '#E0E0E0' }}
                                                                        tickLine={false}
                                                                    />
                                                                    <YAxis 
                                                                        axisLine={false}
                                                                        tickLine={false}
                                                                        tick={{ fontSize: 12, fill: '#9E9E9E' }}
                                                                    />
                                                                    <Tooltip />
                                                                    <Bar
                                                                        dataKey="sub_domain_score"
                                                                        name={`${this.formatSubdomain(subdomain)} Score`}
                                                                        radius={[4, 4, 0, 0]}
                                                                        barSize={32}
                                                                    >
                                                                        {data.map((entry, index) => (
                                                                            <Cell key={`cell-${index}`} fill={this.state.domainColorMap[subdomain] || "#3f51b5"} />
                                                                        ))}
                                                                    </Bar>
                                                                </BarChart>
                                                            </ResponsiveContainer>
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            ))}
                                        </div>
                                    ) : (
                                        Object.keys(chartData).length > 0 && (
                                            <div style={{ marginTop: 20 }}>
                                                {Object.entries(chartData).map(([domain, data]) => (
                                                    <Card className={styles.chartCard} key={domain}>
                                                        <CardContent>
                                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                                <Typography variant="h6" style={{ fontWeight: 700 }}>
                                                                    {domain} Score Comparison
                                                                </Typography>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    className={styles.navButton}
                                                                    onClick={() => this.handleDrilldown(domain)}
                                                                >
                                                                    Drilldown
                                                                </Button>
                                                            </Box>
                                                            <Box mt={4}>
                                                                <ResponsiveContainer width="100%" height={350}>
                                                                    <BarChart
                                                                        data={data}
                                                                        margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                                                                        barCategoryGap="40%"
                                                                    >
                                                                        <XAxis 
                                                                            dataKey="name" 
                                                                            interval={0} 
                                                                            tick={{ fontSize: 12, fontWeight: 600 }}
                                                                            axisLine={{ stroke: '#E0E0E0' }}
                                                                            tickLine={false}
                                                                        />
                                                                        <YAxis 
                                                                            axisLine={false}
                                                                            tickLine={false}
                                                                            tick={{ fontSize: 12, fill: '#9E9E9E' }}
                                                                        />
                                                                        <Tooltip />
                                                                        <Bar
                                                                            dataKey="score"
                                                                            name={`${domain} Score`}
                                                                            radius={[4, 4, 0, 0]}
                                                                            barSize={32}
                                                                        >
                                                                            {data.map((entry, index) => (
                                                                                <Cell key={`cell-${index}`} fill={this.state.domainColorMap[domain] || "#3f51b5"} />
                                                                            ))}
                                                                        </Bar>
                                                                    </BarChart>
                                                                </ResponsiveContainer>
                                                            </Box>
                                                        </CardContent>
                                                    </Card>
                                                ))}
                                            </div>
                                        )
                                    )}

                                    {peers.length > 0 && (
                                        <Box mt={4} className={styles.chartCard} p={3}>
                                            <Typography variant="h6" gutterBottom>List of Peers</Typography>
                                            <Box display="flex" flexWrap="wrap" gap={1}>
                                                {peers.map((p, idx) => (
                                                    <Chip key={idx} label={p} variant="outlined" />
                                                ))}
                                            </Box>
                                        </Box>
                                    )}

                                    <Dialog
                                        open={this.state.variableDialogOpen}
                                        onClose={() => this.setState({ variableDialogOpen: false })}
                                        fullWidth
                                        maxWidth="sm"
                                        PaperProps={{ style: { borderRadius: 16 } }}
                                    >
                                        <DialogTitle style={{ position: 'relative' }}>
                                            <Typography variant="h6" style={{ fontWeight: 700 }}>
                                                Variables for {this.formatSubdomain(this.state.variableDialogSubdomain)}
                                            </Typography>
                                            <IconButton
                                                onClick={() => this.setState({ variableDialogOpen: false })}
                                                style={{ position: 'absolute', right: 8, top: 8 }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </DialogTitle>
                                        <DialogContent dividers>
                                            {this.state.variableList.length === 0 ? (
                                                <Typography variant="body1">No variables found.</Typography>
                                            ) : (
                                                <Box display="flex" flexWrap="wrap">
                                                    {this.state.variableList.map((item, idx) => (
                                                        <Chip
                                                            key={idx}
                                                            label={item}
                                                            className={styles.variableChip}
                                                            style={{
                                                                backgroundColor: ['#E91E63', '#3F51B5', '#009688', '#FF5722', '#4CAF50', '#9C27B0'][idx % 6],
                                                                color: '#fff'
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            )}
                                        </DialogContent>
                                    </Dialog>

                                    <Dialog
                                        open={this.state.dataDialogOpen}
                                        onClose={() => this.setState({ dataDialogOpen: false })}
                                        fullWidth
                                        maxWidth="md"
                                        PaperProps={{ style: { borderRadius: 16 } }}
                                    >
                                        <DialogTitle style={{ position: 'relative' }}>
                                            <Typography variant="h6" style={{ fontWeight: 700 }}>
                                                Data Comparison: {this.formatSubdomain(this.state.variableDialogSubdomain)}
                                            </Typography>
                                            <IconButton
                                                onClick={() => this.setState({ dataDialogOpen: false })}
                                                style={{ position: 'absolute', right: 8, top: 8 }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </DialogTitle>
                                        <DialogContent dividers>
                                            {this.state.fulldata?.length === 0 ? (
                                                <Typography variant="body1">No data found.</Typography>
                                            ) : (
                                                <TableContainer component={Paper} elevation={0}>
                                                    <Table className={styles.dataTable}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell><b>Peer Name</b></TableCell>
                                                                <TableCell><b>Variable Name</b></TableCell>
                                                                <TableCell align="right"><b>Value</b></TableCell>
                                                                <TableCell><b>Unit</b></TableCell>
                                                                <TableCell align="right"><b>Score</b></TableCell>
                                                                <TableCell align="center"><b>Financial Year</b></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {this.state.fulldata?.map((row, idx) => (
                                                                <TableRow key={idx} hover>
                                                                    <TableCell style={{ fontWeight: 600 }}>{row.peer_name}</TableCell>
                                                                    <TableCell>{row.variable_name}</TableCell>
                                                                    <TableCell align="right">
                                                                        {row.variable_value != null ? Number(row.variable_value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                                                    </TableCell>
                                                                    <TableCell>{row.variable_uom || 'N/A'}</TableCell>
                                                                    <TableCell align="right" style={{ 
                                                                        color: row.variable_score > 75 ? '#2ca02c' : row.variable_score > 45 ? '#ff7300' : '#d32f2f',
                                                                        fontWeight: 700 
                                                                    }}>
                                                                        {row.variable_score != null ? Number(row.variable_score).toFixed(2) : '-'}
                                                                    </TableCell>
                                                                    <TableCell align="center">{row.financial_year}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </DialogContent>
                                    </Dialog>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <AsideComponent key="aside" />,
            <FooterComponent key="footer" />
        ];
    }
}
export default connect(null, { startLoader, stopLoader })(PeerBenchmarking);
